import { useTranslation } from 'react-i18next';
import { useSelector } from 'app/lib/hooks';
import { selectSetServiceAccountError } from 'app/store/jobs';
import { Button, ButtonSize } from 'app/components/core/Button';
import { Submit } from 'app/components/core/Form';
import { ErrorBanner } from 'app/components/composite/ErrorBanner';
import { CreateServiceAccountForm } from 'app/components/features/CreateServiceAccountDialog';
import { DialogPanel, DialogActions } from 'app/components/features/DialogWithChapters';

export function ConfigureServiceAccountPanel({ id, account, onCancel }) {
    const { t } = useTranslation();
    const error = useSelector(selectSetServiceAccountError);
    const label = t('jobs:dialogs.serviceAccount.title', {
        context: account ? 'edit' : 'create'
    });

    return (
        <DialogPanel id={id} label={label} open>
            {error && <ErrorBanner error={error} />}
            <CreateServiceAccountForm account={account}>
                <DialogActions>
                    <Button onClick={onCancel} size={ButtonSize.MEDIUM}>
                        {t('common:cancel')}
                    </Button>
                    <Submit size={ButtonSize.MEDIUM}>
                        {account ? t('common:update') : t('common:create')}
                    </Submit>
                </DialogActions>
            </CreateServiceAccountForm>
        </DialogPanel>
    );
}
